<app-ot-breadcrumbs state="price" [city]="city" [otEvent]="otEvent"></app-ot-breadcrumbs>

<div class="container-fluid" *ngIf="otEventInfo && (otEventInfo.full || !otEvent.registrationEnabled)">
  <div class="row">
    <div class="col-lg-8">
      <div class="alert alert-danger" role="alert">
        {{ (otEventInfo.full ? 'error_otEventIsFull' : 'error_otEventRegistrationDisabled') | l10n }}
      </div>
    </div>
    <div class="col-lg-4">
      <div class="card selected-event-card">
        <div class="card-body">
          <h5>{{ 'registration_selectedOtEvent' | l10n }}</h5>
          <app-ot-event-info [otEvent]="otEvent"></app-ot-event-info>
        </div>
      </div>
    </div>
  </div>
</div>

<form #priceForm="ngForm" novalidate *ngIf="otEventInfo && otEvent.registrationEnabled && !otEventInfo.full">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <h1>{{ 'price_title' | l10n }}</h1>

        <!-- Basic price -->
        <div>
          <ul class="discountList">
            <li>
              {{ 'price_basicPrice' | l10n }}
              <span class="badge badge-secondary">{{ registration.basicPrice | price }}</span>
            </li>
          </ul>
        </div>

        <!-- Paid premiums -->
        <div *ngIf="priceModel.premiums.length > 0">
          <h3>{{ 'price_premiums' | l10n }}</h3>
          <ul class="discountList">
            <li *ngFor="let premiumOption of priceModel.premiums; let i = index;">
              <div *ngIf="premiumOption.priceModifier.type.code == 'GeneralPremium'">
                <label>
                  <input id="premium-{{ premiumOption.priceModifier.id }}"
                      name="premium-{{ premiumOption.priceModifier.id }}"
                      type="checkbox"
                      [(ngModel)]="premiumOption.applied"
                      (change)="togglePriceModifier(premiumOption.priceModifier)" />
                  {{ premiumOption.priceModifier.name }}
                </label>
                <span *ngIf="priceModel.registrationPriceModifiersByPriceModifierId[premiumOption.priceModifier.id]" class="badge badge-secondary">+{{ priceModel.registrationPriceModifiersByPriceModifierId[premiumOption.priceModifier.id].amount | price }}</span>

                <div *ngIf="premiumOption.priceModifier.description && premiumOption.applied" class="priceModifierDescriptionBlock">
                  <fa-icon [icon]="['fas', 'info-circle']" class="infoIcon"></fa-icon>
                  <div class="priceModifierDescription" [innerHTML]="premiumOption.priceModifier.description"></div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- Discounts -->
        <div *ngIf="priceModel.userSelectableDiscounts.length > 0 || priceModel.appliedPriceModifierHeightByTypeCode.PartialCourseDiscount">
          <h3>{{ 'price_discounts' | l10n }}</h3>
          <ul class="discountList">

            <li *ngFor="let discountOption of priceModel.userSelectableDiscounts; let i = index;">

              <!-- General discount -->
              <div *ngIf="discountOption.priceModifier.type.code == 'GeneralDiscount'">
                <label>
                  <input id="discount-{{ discountOption.priceModifier.id }}"
                      name="discount-{{ discountOption.priceModifier.id }}"
                      type="checkbox"
                      [(ngModel)]="discountOption.applied"
                      (change)="togglePriceModifier(discountOption.priceModifier)" />
                  {{ discountOption.priceModifier.name }}
                </label>
                <span *ngIf="priceModel.registrationPriceModifiersByPriceModifierId[discountOption.priceModifier.id]" class="badge badge-secondary">-{{ priceModel.registrationPriceModifiersByPriceModifierId[discountOption.priceModifier.id].amount | price }}</span>

                <div *ngIf="discountOption.priceModifier.description && discountOption.applied" class="priceModifierDescriptionBlock">
                  <fa-icon [icon]="['fas', 'info-circle']" class="infoIcon"></fa-icon>
                  <div class="priceModifierDescription" [innerHTML]="discountOption.priceModifier.description"></div>
                </div>
              </div>

              <!-- Social discount -->
              <div *ngIf="discountOption.priceModifier.typeCode == 'SocialDiscount'">
                <label>
                  <input id="discount-{{ discountOption.priceModifier.id }}"
                      name="discount-{{ discountOption.priceModifier.id }}"
                      type="checkbox"
                      [(ngModel)]="discountOption.applied"
                      (change)="togglePriceModifier(discountOption.priceModifier)"
                      [disabled]="priceModel.appliedPriceModifierIdByTypeCode.SocialDiscount && priceModel.appliedPriceModifierIdByTypeCode.SocialDiscount !== discountOption.priceModifier.id" />
                  <span *ngIf="discountOption.priceModifier.name">{{ discountOption.priceModifier.name }}</span>
                  <span *ngIf="! discountOption.priceModifier.name">
                    {{ 'price_socialDiscount' | l10n }}
                    <span *ngFor="let socialGroup of discountOption.priceModifier.socialDiscount.socialGroups; let i = index; let last = last">{{ socialGroup.accusative }}{{ last ? '' : ', ' }}</span>
                  </span>
                </label>
                <span *ngIf="priceModel.registrationPriceModifiersByPriceModifierId[discountOption.priceModifier.id] != undefined" class="badge badge-secondary">-{{ priceModel.registrationPriceModifiersByPriceModifierId[discountOption.priceModifier.id]?.amount | price }}</span>
                <div *ngIf="priceModel.registrationPriceModifiersByPriceModifierId[discountOption.priceModifier.id]" class="ml1Line">
                  <label class="required personalData-chooseSocialGroup-label">{{ 'price_chooseSocialGroup' | l10n }}:</label>
                  <div *ngIf="submitted && priceModel.registrationPriceModifiersByPriceModifierId[discountOption.priceModifier.id].registrationSocialDiscount.socialGroupId == undefined" class="validationError">
                    <span>{{ 'price_validation_chooseSocialGroup' | l10n }}</span>
                  </div>
                  <ul class="personalData-socialGroup-list">
                    <li *ngFor="let socialGroup of discountOption.priceModifier.socialDiscount.socialGroups; let i = index;">
                      <label>
                        <input type="radio"
                            name="socialGroup-{{ discountOption.priceModifier.id }}-{{ socialGroup.id }}"
                            [(ngModel)]="priceModel.registrationPriceModifiersByPriceModifierId[discountOption.priceModifier.id].registrationSocialDiscount.socialGroupId"
                            (change)="socialGroupChanged(priceModel.registrationPriceModifiersByPriceModifierId[discountOption.priceModifier.id])"
                            [value]="socialGroup.id" />
                        {{ socialGroup.name }}
                      </label>
                    </li>
                  </ul>
                </div>
                <div *ngIf="discountOption.priceModifier.description && discountOption.applied" class="priceModifierDescriptionBlock">
                  <fa-icon [icon]="['fas', 'info-circle']" class="infoIcon"></fa-icon>
                  <div class="priceModifierDescription" [innerHTML]="discountOption.priceModifier.description"></div>
                </div>
              </div>
            </li>

            <!-- Partial course discount - it's displayed just once even if there are multiple PriceModifiers of its type -->
            <li *ngIf="priceModel.appliedPriceModifierHeightByTypeCode.PartialCourseDiscount">
              <div>
                <label><input type="checkbox" disabled checked /> {{ 'price_lateRegDiscountInfo' | l10n }} <span class="badge badge-secondary">-{{ priceModel.appliedPriceModifierHeightByTypeCode.PartialCourseDiscount | price }}</span></label>
              </div>
            </li>
          </ul>
        </div>

        <!-- Final price -->
        <div class="personalData-totalPriceBlock">
          <h3>{{ 'price_totalPrice' | l10n }}</h3>

          <span class="badge badge-primary totalPrice {{ priceChangeAlert ? 'price-change-alert-add' : 'price-change-alert-remove' }}">{{ registration.price | price }}</span>
          <span *ngIf="registration.registrationPriceModifiers && registration.registrationPriceModifiers.length"></span>
        </div>

        <h2>{{ 'price_paymentType_title' | l10n }}</h2>
        <ul>
          <li *ngFor="let paymentTypeConfig of otEvent.organization.paymentTypeConfigs; let i = index;" [hidden]="! paymentTypeConfig.enabled">
            <label><input type="radio" #paymentType="ngModel" name="paymentType" [(ngModel)]="registration.paymentTypeConfigId" [value]="paymentTypeConfig.id" required /> {{ 'paymentType_' + paymentTypeConfig.paymentTypeCode | l10n }} <span *ngIf="paymentTypeConfig.name">({{ paymentTypeConfig.name }})</span></label><br/>
            <p class="description ml1Line">{{ 'paymentType_' + paymentTypeConfig.paymentTypeCode + '_info' | l10n }}</p>
          </li>
        </ul>
        <div *ngIf="submitted && ! registration.paymentTypeConfigId" class="validationError mb1em">
          <span *ngIf="paymentType.errors.required">{{ 'price_selectPaymentType' | l10n }}</span>
        </div>

        <div *ngIf="otEvent.organization.paymentNotes">
          <h3>{{ 'organization_paymentNotes' | l10n }}</h3>
          <p class="description">{{ otEvent.organization.paymentNotes }}</p>
        </div>

        <button type="button" class="btn btn-primary mt1em" (click)="goToNextStep(priceForm.valid)">{{ 'price_goToPersonInfo' | l10n }} <fa-icon [icon]="['fas', 'chevron-right']" class="button-icon-right"></fa-icon></button>
      </div>
      <div class="col-lg-3">
        <app-ot-event-info [otEvent]="otEvent"></app-ot-event-info>
      </div>
    </div>
  </div>
</form>
